import React from "react";

const Logo = () => (
  <img src="/QuickRunner.jpg" alt="Quick Runner Logo" className="h-10 w-auto" />
);

export default Logo;
